import { render, staticRenderFns } from "./NflPlayerTrends.vue?vue&type=template&id=499ff4da&scoped=true"
import script from "./NflPlayerTrends.vue?vue&type=script&lang=js"
export * from "./NflPlayerTrends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499ff4da",
  null
  
)

export default component.exports